import React, { CSSProperties } from 'react'
//import { useRouter } from 'next/router'
import styled, { css } from 'styled-components'
//import SignIn from '@App/session/components/SignIn'
import SSOButton from './SSOButtons'
import classNames from 'classnames'
import { presenterHub } from '@RestApi/types'
import { sharedMessages as commonMessages } from '@Locales/index'
import { HubFormattedMessage } from 'src/common/rtl/HubTextFormatting'
import EmailSignInForm from './EmailSignInForm'
import media from '@Styles/media'
import messages from '@App/session/messages'
import Join from './Join'

type props = {
  hub: presenterHub
  action: string
  loading: boolean
  isAuthorized: boolean
  badEmailError: boolean
  emptyEmailError: boolean
  emailAddress: string
  password: string
  handleSetEmailAddress: (e: React.ChangeEvent<HTMLInputElement>) => void
  resetAction: () => void
  handleEmailSubmit: () => void
  handlePasswordSubmit: (password: string) => void
  handleSignIn: () => Promise<void>
  showResetPassword: () => void
  hideRequestResetPassword: () => void
  className?: CSSProperties
}

const LoginModal: React.FC<props> = (props: props) => {
  const { hub, className, showResetPassword, hideRequestResetPassword, ...rest } = props
  // const router = useRouter()
  const hubWelcomeMessage = hub.settings.welcome_message
  const isJoinEnabled = hub.settings.enable_join_now
  const isEmailFormEnabled = !hub.settings.auth_options.disable_email_form
  const SSOButtons = hub.sso_buttons
  const joinNowURL = hub.settings.join_now_url
  // const [tryAgain, setTryAgain] = useState<boolean>(false)
  //const [email, setEmail] = useState<string[] | string>(router.query.email || '')

  // const onChangeEmail = (e: any) => {
  // this.setState({ email: e.currentTarget.value })
  //  setEmail(e.currentTarget.value)
  // }

  //TODO ... add a turnary for joinin case
  const renderHubInfo = () => {
    if (isEmailFormEnabled || isJoinEnabled || (SSOButtons && SSOButtons.length > 0)) {
      return <HubFormattedMessage {...messages.signIn} />
    }
  }

  const renderWelcomeMessage = () => {
    if (!isEmailFormEnabled && !isJoinEnabled && !SSOButtons && !hubWelcomeMessage) {
      return (
        <HubFormattedMessage
          {...messages.defaultWelcomeMessage}
          values={{
            lineBreak: <br />,
            link: <a href="https://www.alida.com/">Alida.com</a>,
          }}
        />
      )
    }
    return hubWelcomeMessage
  }
  /* const isHorizontal = (SSOButtons &&
    SSOButtons.length > 1 &&
    (isEmailFormEnabled || isJoinEnabled)) as boolean*/

  const isHorizontal = (SSOButtons &&
    SSOButtons.length > 1 &&
    (isEmailFormEnabled || isJoinEnabled)) as boolean

  return (
    <Container>
      <RenderHubInfoBlock>
        <Title>{renderHubInfo()}</Title>
        <WelcomeTitle> {renderWelcomeMessage()}</WelcomeTitle>
      </RenderHubInfoBlock>

      <Heading isHorizontal={isHorizontal}>
        <LeftSignInContainer>
          {isEmailFormEnabled && (
            <EmailSignInForm hub={hub} showResetPassword={showResetPassword} {...rest} />
          )}
          {!isEmailFormEnabled && isJoinEnabled && <Join joinNowURL={joinNowURL} />}
        </LeftSignInContainer>
        <SSOFormContainer
          role="form"
          className={classNames('px-email-signin-container', className)}
          isHorizontal={isHorizontal}
        >
          {(isEmailFormEnabled || isJoinEnabled) && (
            <StrikeTrough isHorizontal={(SSOButtons && SSOButtons.length < 2) as boolean}>
              <span>
                <HubFormattedMessage {...commonMessages.or} />
              </span>
            </StrikeTrough>
          )}

          <Block>
            {SSOButtons &&
              SSOButtons.map((item, index) => <SSOButton key={index} provider={item} />)}
          </Block>
        </SSOFormContainer>
      </Heading>
    </Container>
  )
}
export default LoginModal

const Container = styled.div`
  max-width: 800px;
`

const SSOFormContainer = styled.div<{ isHorizontal: boolean }>`
  max-width: auto;
  display: flex;
  flex-direction: ${({ isHorizontal }) => (isHorizontal ? 'row' : 'column')};
  position: relative;
  justify-content: center;
  align-items: center;
  ${media.smallScreen`
    padding-top: ${({ theme }: any) => theme.sizes.gutterSmall};
  `};
  ${media.smallerThanLargeScreen`
    flex-direction: column;
  `}
`
const LeftSignInContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
const WelcomeTitle = styled.div`
  margin: 25px 0;
  font-size: ${({ theme }) => theme.fontSizes.fontSizeSmall};
  color: ${({ theme }) => theme.colors.grayDarker};
`

const Block = styled.div`
  width: 300px;
`

const StrikeTrough = styled.div<{ isHorizontal: boolean }>`
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  align-self: center;
  text-transform: uppercase;
  font-weight: bold;
  ${({ isHorizontal }) =>
    isHorizontal
      ? css`
          margin-top: 20px;
          width: 100%;
        `
      : css`
          height: 100%;
          padding: 0 40px;
        `}
  ${media.smallerThanLargeScreen`
    margin-top: 20px;
    width: 100%;
  `}
    span {
    font-size: ${({ theme }) => theme.fontSizes.fontSizeSmall};
    background-color: #ffffff;
    padding: 10px;
    font-weight: 500;
    color: #1a1a1a;
  }

  &:before {
    display: block;
    content: '';
    background-color: #bbb;
    position: absolute;
    z-index: -1;
    ${({ isHorizontal }) =>
      isHorizontal
        ? css`
            width: 100%;
            height: 2px;
          `
        : css`
            width: 2px;
            height: 100%;
          `}

    ${media.smallerThanLargeScreen`
      width: 100%;
      height: 2px;
  `}
  }
`
//const BLACK = '#1a1a1a'
//const HEADER_FONT_SIZE = '21px'
//const HEADER_FONT_WEIGHT = '500'

const Title = styled.div`
  font-weight: 500;
  font-size: ${({ theme }) => theme.fontSizes.fontSizeLarge};
  color: black;
`
const RenderHubInfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Droid Sans'; //replace with a font from backend
`

const Heading = styled.div<{ isHorizontal?: boolean }>`
  display: flex;
  flex-direction: ${({ isHorizontal }) => (isHorizontal ? 'row' : 'column')};
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.fontSizeSmall};
  color: ${({ theme }) => theme.colors.detailColor};
  //max-width: ${({ isHorizontal }) => (isHorizontal ? '800px' : '300px')};
  @media (max-width: 900px) {
    width: 300px;
    flex-direction: column;
  }
`
